import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../../types/types';
import { PrefixesPanelButton } from '../../components/PrefixesPanelButton/PrefixesPanelButton';
import { IPrefixesPanelButtonEvents, IPrefixesPanelButtonFields } from '../../components/PrefixesPanelButton/types';
import { getCardNumberByBoardId } from '../../store/cardNumbers/selectors/getCardNumberByBoardId';
import { onClick } from './events/onClick';
import { IPrefixesPanelButtonHOCProps } from './types';
import {
    getIsUserEssentialPlanOnly
} from '../../../../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IPrefixesPanelButtonHOCProps
): IPrefixesPanelButtonFields => {
    const { enabled: indicatorBoolean } = getCardNumberByBoardId(state, boardId);
    return {
        indicatorBoolean,
        isEssentialFeature: getIsUserEssentialPlanOnly(state),
        tooltip: null,
    }
};

const mapDispatchToProps = (
    dispatch: any,
    {onClick: ownOnClick}: IPrefixesPanelButtonHOCProps
): IPrefixesPanelButtonEvents => {
    return {
        onClick: () => dispatch(onClick(ownOnClick))
    }
};

export const PrefixesPanelButtonHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(PrefixesPanelButton);

PrefixesPanelButtonHOC.displayName = 'PrefixesPanelButtonHOC';
